import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import BarChart from '../charts/BarChart';
import type { Task } from '../../services/api/tasksService';

interface Props {
  tasks: Task[];
}

export default function CrewDemandWidget({ tasks }: Props) {
  const byTeam = new Map<string, number>();
  for (const t of tasks) {
    const key = t.team?.name || 'Unassigned';
    const hours = t.estimatedHours ?? 8;
    byTeam.set(key, (byTeam.get(key) || 0) + hours);
  }

  const labels = Array.from(byTeam.keys());
  const data = labels.map((l) => byTeam.get(l) || 0);

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Crew demand (estimated hours)
      </Typography>
      {labels.length === 0 ? (
        <Box sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>
          No crew demand in the window.
        </Box>
      ) : (
        <BarChart
          labels={labels}
          datasets={[
            {
              label: 'Estimated hours',
              data,
              backgroundColor: '#1976d2',
            },
          ]}
          height={260}
          showLegend={false}
          yAxisLabel="Hours"
        />
      )}
    </Paper>
  );
}
